<template src="./InputNumberComponent.html"></template>

<script>
export default {
  name: 'InputNumberComponent',
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: () => false
    },
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false,
      default: () => ''
    },
    valueDefault: {
      type: Number,
      required: false,
      default: () => 0
    },
    placeholder: {
      type: String,
      required: false,
      default: () => ''
    },
    errorText: {
      type: String,
      required: false,
      default: () => ''
    },
    isError: {
      type: Boolean,
      required: false,
      default: () => false
    },
    required: {
      type: Boolean,
      required: false,
      default: () => false
    },
  },
  created() {
    if (this.valueDefault) {
      this.value = this.valueDefault
    }
  },
  data() {
    return {
      value: 0
    }
  },
  watch: {
    value() {
      this.$emit('inputValue', this.value)
    },
    valueDefault() {
      this.value = this.valueDefault
    }
  },
  methods: {
    onBlur() {
      if (this.required) {
        this.$emit('blur', this.value)
      }
    }
  }
}
</script>

<style lang="scss">
.error-text {
  color: red;
  margin: 0;
}
.is-error {
  border: 1px solid red;
}
</style>
